import styled from 'styled-components';

export const LoginContainer = styled.div`
  height: 100%;
  max-height: 100vh;
  padding: 1rem;
`;
